// src/Components/Forms/Financement/Salam/Proposition/Proposition.tsx
import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import Table from '../../../../TableResizable';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import axios from 'axios';
import { Box, Typography } from '@mui/material';
import Tab1 from './Tab1';
import Tab2 from './Tab2';
import Tab3 from './Tab3';
import Utilisateur from '../../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import Data from '../../../../../Data/Data.json';
import SweetAlert from "sweetalert2";
import { Crypter } from '../../../../../Functions/Security/Crypter';
import { ColumnsType } from 'antd/es/table';
import formatNumber from '../../../../../Functions/Traitement/FormatNumber';
import ReformatDate from '../../../../../Functions/Traitement/ReformatDate';
import ParamsPicklist from '../../../../../Types/ParamsPicklist';
import { DemandeSalamDto } from '../../../../../Models/DemandeSalam';

const Contratsalam = () => {
  const auth = useAuthUser();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
  const authHeader = useAuthHeader();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [, forceUpdate] = useState({});
  const [ajoutActve, setAjoutActif] = useState(false);
  const [modifActve, setModifActve] = useState(true);
  const [enregActve, setEnregActve] = useState(true);
  const [supActive, setSupActive] = useState(true);
  const [impActive, setImpActive] = useState(true);
  const [actuActive, setActActive] = useState(true);
  const [annulActive, setAnnulActive] = useState(true);
  const [consulActive, setConsulActive] = useState(false);
  const [pageLoad, setPageLoad] = useState(true);
  const [sbmit, setSbmit] = useState("");
  const [data, setData] = useState<any[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [radioaCheck, setRadioaCheck] = useState(false);

  // ===== ÉTATS POUR LES FRAIS =====
  const [fraisData, setFraisData] = useState<any[]>([]);
  const [fraisOptions, setFraisOptions] = useState<{ value: string; label: string }[]>([]);
  const [fraisSelectionnes, setFraisSelectionnes] = useState<string[]>([]);

  // Observateurs
  const CodeSalam = Form.useWatch('CodeSalam', form);
  const MontantPropose = Form.useWatch('MontantPropose', form) || 0;

  // ===== CHARGEMENT DES PARAMÈTRES SALAM (FRAIS) =====
  const loadFraisParams = (codeSalam: string) => {
    if (!codeSalam) {
      setFraisData([]);
      setFraisOptions([]);
      setFraisSelectionnes([]);
      form.setFieldValue('FraisService', 0);
      form.setFieldValue('CodeFrais', []);
      return;
    }

    const config = {
      method: 'get',
      url: Data.ApiUrl.ReadParamsSalam,
      headers: {
        'CypherCodeSalam': Crypter.encrypt(codeSalam),
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      }
    };

    axios.request(config)
      .then(response => {
        const res = JSON.parse(Crypter.decrypt(response.data)).Value;
        if (res.StatutCode === 200) {
          const table4 = res.Result.Table4 || [];
          setFraisData(table4);

          const options = table4.map((item: any) => ({
            value: item.CODOPE,
            label: `${item.CODOPE} - ${item.LIBELL || ''}`
          }));
          setFraisOptions(options);

          // Par défaut, on sélectionne tous les frais
          let savedFrais = form.getFieldValue('CodeFrais') || [];
          if (savedFrais.length === 0 && table4.length > 0) {
            savedFrais = table4.map((item: any) => item.CODOPE);
            form.setFieldValue('CodeFrais', savedFrais);
          }
          setFraisSelectionnes(savedFrais);
        }
      })
      .catch(error => {
        console.error("Erreur chargement paramètres Salam:", error);
        setFraisData([]);
        setFraisOptions([]);
        setFraisSelectionnes([]);
        form.setFieldValue('FraisService', 0);
        form.setFieldValue('CodeFrais', []);
      });
  };

  // Déclencher le chargement des frais quand CodeSalam change
  useEffect(() => {
    loadFraisParams(CodeSalam);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [CodeSalam]);

  // Recalcul des frais à chaque changement de MontantPropose ou de sélection
  useEffect(() => {
    let total = 0;
    fraisData.forEach((item: any) => {
      if (fraisSelectionnes.includes(item.CODOPE)) {
        total += Number(item.MONFIX || 0) + (Number(item.POURCE || 0) / 100) * MontantPropose;
      }
    });
    form.setFieldValue('FraisService', Math.round(total * 100) / 100);
  }, [MontantPropose, fraisData, fraisSelectionnes, form]);

  // ===== CHARGEMENT DES DEMANDES (inchangé) =====
  useEffect(() => {
    if (pageLoad) {
      localStorage.clear();
      setPageLoad(false);
      setLoading(true);
      setData([]);

      let searchClientComptes: ParamsPicklist = {
        CodeAgence: user.codage,
        Table: "DEMAND_FINSALAM",
        Colonne1: "EtapeActuelle",
        Colonne2: "",
        Init: "CONTRAT",
        Colagence: 'CODAGE',
        Choix: 34
      };

      var config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.AnySearch,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authHeader(),
          'CypherSearch': Crypter.encrypt(JSON.stringify(searchClientComptes))
        }
      };
      axios(config)
        .then((response) => {
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
            if (res.StatutCode == 200) {
              let datas = res.Result.Table;
              if (datas.length === 0) {
                SweetAlert.fire({
                  title: "Aucune demande Salam en cours",
                  text: "Toutes les demandes ont été traitées ou aucune demande n'est en état 'DEMANDE'.",
                  icon: "info"
                });
              } else {
                const newData = datas.map((item: any, index: number) => ({
                  key: index,
                  NumeroDemande: item.NumeroDemande,
                  NUMCLI: item.NUMCLI,
                  NOMCLI: item.NOMCLI,
                  DateDemande: item.DateDemande ? new Date(item.DateDemande).toLocaleDateString('fr') : '',
                  CodeSalam: item.CodeSalam,
                  MontantDemande: formatNumber(item.MontantDemande),
                  EtapeActuelle: item.EtapeActuelle,
                  ...item
                }));
                setData(newData);
              }
            }
          }
          setLoading(false);
        }).catch((error) => {
          setLoading(false);
          SweetAlert.fire({
            title: "Erreur",
            text: error.toString(),
            icon: "error"
          });
        });
    }
  }, [pageLoad, user.codage, authHeader]);

  const columns: ColumnsType<any> = [
    { title: 'N° Demande', dataIndex: 'NumeroDemande' },
    { title: 'N° Client', dataIndex: 'NUMCLI' },
    { title: 'Client', dataIndex: 'NOMCLI' },
    { title: 'Date Demande', dataIndex: 'DateDemande' },
    { title: 'Type Salam', dataIndex: 'CodeSalam' },
    { title: 'Montant Demandé', dataIndex: 'MontantDemande' },
    { title: 'État', dataIndex: 'EtapeActuelle' }
  ];

  useEffect(() => {
    forceUpdate({});
  }, []);

  function initialiazeButton() {
    setAjoutActif(false);
    setModifActve(true);
    setEnregActve(true);
    setSupActive(true);
    setImpActive(true);
    setActActive(true);
    setAnnulActive(true);
    setConsulActive(false);
  }

  function handleAnulle() {
    setRadioaCheck(false);
    setImpActive(true);
    form.resetFields();
    localStorage.clear();
    initialiazeButton();
    localStorage.setItem(Data.LocalVariable.reset, "1");
    localStorage.setItem(Data.LocalVariable.Mainreset, "1");
    setSelectedRowKeys([]);
    // Réinitialiser les frais
    setFraisData([]);
    setFraisOptions([]);
    setFraisSelectionnes([]);
    form.setFieldValue('FraisService', 0);
    form.setFieldValue('CodeFrais', []);
  }

  function cunsultButton() {
    setAnnulActive(false);
    setModifActve(false);
  }

  function modifButton() {
    setRadioaCheck(true);
    setSbmit("update");
    setModifActve(true);
    setAjoutActif(true);
    setEnregActve(false);
    setConsulActive(true);
  }

  // Chargement des détails d'une demande
  function handleDemandePret() {
    const numero = form.getFieldValue("NumeroDemande");
    if (!numero) {
      SweetAlert.fire({
        title: "Demande non sélectionnée",
        text: "Veuillez sélectionner une demande dans le tableau.",
        icon: "warning"
      });
      return;
    }
    setLoading(true);
    const encryptedNumero = Crypter.encrypt(numero);
    const encryptedAction = Crypter.encrypt("READ_DEMANDE");
    const config = {
      method: 'POST',
      url: Data.ApiUrl.ReadFinancementSalam,
      headers: {
        'Authorization': authHeader(),
        'Content-Type': 'application/json',
        'CypherNumeroDemandeSalam': encryptedNumero,
        'CypherAction': encryptedAction
      }
    };
    axios.request(config)
      .then(response => {
        setLoading(false);
        const res = JSON.parse(Crypter.decrypt(response.data)).Value;
        if (res.StatutCode === 200) {
          const data = res.Result.Table1[0];
          const codeFrais = data.CodeFrais || [];

          // Mettre à jour le formulaire
          const formValues = {
            ...data,
            DateLivraison: data.DateLivraison ? ReformatDate(data.DateLivraison) : '',
            MontantPropose: data.MontantDemande,
            PrixUnitaire: data.Quantite > 0 && data.MontantDemande > 0
              ? Math.round((data.MontantDemande / data.Quantite) * 100) / 100
              : 0,
            CodeFrais: codeFrais,
          };
          form.setFieldsValue(formValues);

          // Charger les paramètres Salam pour obtenir les options
          loadFraisParams(data.CodeSalam);
          // Appliquer la sélection existante
          setFraisSelectionnes(codeFrais);

          // Garanties
          const garanties = res.Result.Table2 || [];
          if (garanties.length > 0) {
            const mappedGaranties = garanties.map((g: any) => ({
              codgar: g.CodeGarantie,
              ...g,
              valCouvert: g.MontantCouvert,
              VALGARANTI: g.VALGARANTI || 0,
            }));
            localStorage.setItem(Data.LocalVariable.garantie, JSON.stringify(mappedGaranties));
          } else {
            localStorage.removeItem(Data.LocalVariable.garantie);
          }
          cunsultButton();
        } else {
          SweetAlert.fire({
            title: res.Message,
            text: res.Result || "Vérifiez le numéro de la demande.",
            icon: "warning"
          });
        }
      })
      .catch(error => {
        setLoading(false);
        console.error(error);
        SweetAlert.fire({
          title: "Erreur",
          text: error.toString(),
          icon: "error"
        });
      });
  }

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: <span><UserOutlined /> Détails demande</span>,
      children: <Tab1 form={form} />,
    },
    {
      key: '2',
      label: <span><UserOutlined /> Garanties</span>,
      children: <Tab2 form={form} />,
    },
    {
      key: '3',
      label: <span><UserOutlined /> Documents</span>,
      children: <Tab3 form={form} disabled={!ajoutActve} />,
    }
    // {
    //   key: '4',
    //   label: <span><UserOutlined /> Frais de Service</span>,
    //   children: (
    //     <Tab4
    //       form={form}
    //       fraisOptions={fraisOptions}
    //       fraisSelectionnes={fraisSelectionnes}
    //       setFraisSelectionnes={setFraisSelectionnes}
    //     />
    //   ),
    // }
  ];

  const onFinishFailed = async (errorInfo: any) => {
    const errors = errorInfo.errorFields.map((error: any) => error.name.join('.'));
    SweetAlert.fire({
      title: "Champs obligatoires",
      text: "Veuillez remplir tous les champs requis : " + errors.join(' - '),
      icon: 'warning'
    });
  };

  const onFinish = (values: any) => {
    if (!values.NumeroDemande) {
      SweetAlert.fire({
        title: "Demande non sélectionnée",
        text: "Veuillez sélectionner une demande avant de proposer.",
        icon: "warning"
      });
      return;
    }

    const montantPropose = parseFloat(values.MontantPropose) || 0;
    const quantite = parseInt(values.Quantite) || 0;
    const gestionnaire = values.CODGEA || '';

    const propositionPayload = {
      NumeroDemande: values.NumeroDemande,
      UtilPropose: user.coduti,
      MontantPropose: montantPropose,
      CommentairePropose: values.CommentaireDemande || '',
      Quantite: quantite,
      CODGEA: gestionnaire,
      Documents: values.Documents || [],
      CodeFrais: values.CodeFrais || [], // Ajout des frais sélectionnés
    };

    SweetAlert.fire({
      title: `Voulez-vous proposer le financement Salam de type ${values.CodeSalam}\n du client : ${values.NUMCLI}\n à hauteur du montant : ${formatNumber(values.MontantPropose)} XAF ?`,
      showCancelButton: true,
      confirmButtonText: "Oui, proposer",
      cancelButtonText: "Annuler",
      icon: "question",
      confirmButtonColor: "green",
      cancelButtonColor: "darkred"
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        const data = Crypter.encrypt(JSON.stringify(propositionPayload));
        axios({
          method: 'post',
          url: Data.ApiUrl.PropositionSalam,
          data: data,
          headers: {
            'Authorization': authHeader(),
            'Content-Type': 'application/json'
          }
        })
        .then((response) => {
          setLoading(false);
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          if (res.StatutCode === 200 || res.StatutCode === 201) {
            SweetAlert.fire({
              title: res.Message || "Proposition réussie",
              text: res.Result,
              icon: "success"
            });
            handleAnulle();
            setPageLoad(true);
          } else {
            SweetAlert.fire({
              title: res.Message || "Erreur lors de la proposition",
              text: res.Result || "Veuillez réessayer.",
              icon: "warning"
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          console.error(error);
          SweetAlert.fire({
            title: "Erreur",
            text: error.toString(),
            icon: "error"
          });
        });
      }
    });
  };

  function modif() {
    modifButton();
  }

  const onSelectChange = (newSelectedRowKeys: any) => {
    const record = data[newSelectedRowKeys];
    if (record) {
      form.setFieldsValue(record);
      handleDemandePret();
    }
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  setTimeout(() => {
    try {
      let reset = localStorage.getItem(Data.LocalVariable.Mainreset);
      if (reset == "1") {
        setSelectedRowKeys([]);
        localStorage.removeItem(Data.LocalVariable.Mainreset);
      }
    } catch (error) { }
  }, 0.1);

  return (
    <div className='tab'>
      <Typography align='center' className='formTitle'><b>PROPOSITION DE FINANCEMENT SALAM</b></Typography>
      <Spin spinning={loading} size='large' style={{ color: 'green' }}>
        <Form
          disabled={!ajoutActve}
          autoComplete="off"
          labelAlign='left'
          form={form}
          name="proposition_salam"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          style={{ minWidth: 'auto', maxWidth: 'auto' }}
        >
          <div className='bG'>
            <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
            <Form.Item shouldUpdate className='bouttong'>
              <Space direction="vertical" style={{ width: '100%' }}>
                <Button
                  size='large'
                  className='bt_add'
                  disabled={modifActve}
                  onClick={modif}
                  type="ghost"
                  htmlType="button"
                  block
                >
                  Modifier
                </Button>
                <Button
                  size='large'
                  className='bt_add'
                  disabled={enregActve}
                  type="ghost"
                  htmlType="submit"
                  block
                >
                  Contrat
                </Button>
                <Button
                  size='large'
                  disabled={annulActive}
                  onClick={handleAnulle}
                  className='bt_add'
                  type="ghost"
                  htmlType="reset"
                  block
                >
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className='clientP'>
            <div>
              <Tabs size='small' type="card" defaultActiveKey="1" items={items} />
              <Box display={"flex"} fontStyle="inherit" className='border-left tabElementAuto' sx={{ mt: 9 }}>
  <Spin spinning={loading}>
    <Form disabled={radioaCheck}>
      <Table
        size='small'
        style={{ width: 'auto' }}
        rowSelection={{ ...rowSelection, type: "radio" }}
        columns={columns}
        dataSource={data}
        scroll={{ y: 190, x: 10 }}
        pagination={false}
      />
    </Form>
  </Spin>
</Box>
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
};

export default Contratsalam;